

<template>
  <div class="results">
    <div class="ind" v-if="value"><input v-model="value.title" class="link"/><br><a class="url" href="#">https://www.mamamia.com.au/{{slug}} ▾</a>

      <textarea
        class="desc"
        v-model="value.description"
        type="text"
        placeholder="Enter between 120 and 156 characters"
      ></textarea>

    </div>
  </div>
</template>

<script>
export default {
    props:[
        'slug',
        'value'
    ],
    watch: {
      value: function () {
        this.model = this.value;
        this.$emit('input', this.model);
      }
    },
    // After first time render.
    mounted: function() {

    },

    data: function () {

      return {

      };
    }
}
</script>

<style scoped>


.results {
  padding:10px;
  background-color:white;
  font-size:inherit;
  font-family: "Arial";
  position: relative;
  display: block;
  width: 100%;
}


.link {
  border: 0 !important;
  font-size: 20px !important;
  text-decoration: none !important;
  color: #1a0dab !important;
  width:100% !important;
}
.link:hover {
  text-decoration: underline;
}

.url {
  color: #005900 !important;
  margin: 0px;
  font-size: 14px;
}

.desc {
    color: #545454 !important;
    font-family: arial,sans-serif !important;
    font-size: 13px !important;
    line-height: 1.54 !important;
    width: 100% !important;
    border: 0 !important;
    height: 62px !important;
    overflow: hidden;
    padding-left:0;
}

</style>


// WEBPACK FOOTER //
// GooglePreview.vue?39a5d536